// extracted by mini-css-extract-plugin
export default {"counter":"_3mgSp","viewCount":"_2fE3Y","commentCount":"_5kt_t","replyCount":"_3hyVl"};